<script lang="ts">
    import type { Setting, SettingsLayoutItem } from "..";

    import { Components, getSetting } from ".";
    import { SettingComp } from "../component";

    export let layout: SettingsLayoutItem;
    export let settings: Setting[];
</script>

<!----------------------------------------------------------------------------->

{#if typeof layout === "string"}
    <SettingComp setting={getSetting(settings, layout)} />
{:else if layout.type === "custom"}
    <svelte:component this={layout.component} {layout} {settings} />
{:else}
    <svelte:component this={Components[layout.type]} {layout} {settings} />
{/if}

<!----------------------------------------------------------------------------->

<style></style>
